import React from "react";
import {
  makeStyles,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@material-ui/core";

import { WebTrackerManagerColumn, WebTrackerManagerSort } from "./sort";
import ColumnLabelWithTooltip from "../ColumnLabelWithTooltip";

const useStyles = makeStyles((_) => ({
  viewDetailsColumn: {
    width: "11em",
  },
}));

export type SharedTableHeadProps = {
  columns: WebTrackerManagerColumn[];
  sort: WebTrackerManagerSort;
  onSort: (column: string) => void;
};

function SharedTableHead({ columns, sort, onSort }: SharedTableHeadProps) {
  const classes = useStyles();

  return (
    <TableHead>
      <TableRow>
        {columns.map((column) => (
          <TableCell
            key={`tracker-column-${column.name}`}
            align={column.align}
            style={column.tableCellStyles}
          >
            {column.isSortable ? (
              <TableSortLabel
                active={sort.column === column.name}
                direction={sort.direction}
                onClick={() => onSort(column.name)}
                style={column.labelStyles}
              >
                <ColumnLabelWithTooltip
                  label={column.name}
                  tooltip={column.tooltip}
                />
              </TableSortLabel>
            ) : (
              <ColumnLabelWithTooltip
                label={column.name}
                tooltip={column.tooltip}
              />
            )}
          </TableCell>
        ))}
        <TableCell className={classes.viewDetailsColumn}></TableCell>
      </TableRow>
    </TableHead>
  );
}

export default SharedTableHead;
